import { X } from "lucide-react";
import type { ReactNode } from "react";

type DrawerProps = {
  title: string;
  eyebrow?: string;
  children: ReactNode;
  onClose: () => void;
};

export function Drawer({ title, eyebrow, children, onClose }: DrawerProps) {
  return (
    <aside className="detail-drawer" aria-label={`${title} 상세`}>
      <div className="drawer-head">
        <div>
          {eyebrow ? <span>{eyebrow}</span> : null}
          <h2>{title}</h2>
        </div>
        <button type="button" className="icon-button" onClick={onClose} aria-label="상세 닫기">
          <X size={16} />
        </button>
      </div>
      <div className="drawer-body">{children}</div>
    </aside>
  );
}
